import { inject, Injectable } from "@angular/core";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { Observable } from "rxjs";
import { parseApiResponseArray } from "@helpers/functions";
import { map } from "rxjs/operators";
import { PromptsModel } from "@modules/messaging-prompts/domain/entities/prompts.model";

interface PromptApiModel {
	id: string;
	event: EventPromptsApiModel;
}

interface EventPromptsApiModel {
	name: string;
	short_title: string;
	title: string;
	subtitle: string;
	button_title: string;
	target_path: string;
	created_at: EventPromptApiModelCreatedAt;
}

interface EventPromptApiModelCreatedAt {
	date_iso8601?: string;
	unix?: string;
}

@Injectable({
	providedIn: "root"
})
export class PromptsRemote {
	private readonly apiCallService = inject(ApicallService);

	public getPrompts$: Observable<PromptsModel[]> = this.apiCallService.get("prompts", this.getPromotsOptions()).pipe(
		map((response) => parseApiResponseArray<PromptApiModel>(response)),
		map((response) => {
			return response.map((prompt) => {
				return {
					id: prompt.id,
					event: {
						name: prompt.event.name,
						shortTitle: prompt.event.short_title,
						title: prompt.event.title,
						subtitle: prompt.event.subtitle,
						buttonTitle: prompt.event.button_title,
						targetPath: prompt.event.target_path,
						created_at: prompt.event.created_at.date_iso8601
					}
				};
			});
		})
	);

	private getPromotsOptions(): ApicallOption {
		const option = new ApicallOption();
		option.created = true;
		return option;
	}

	public postPrompt$(id: string): Observable<void> {
		return this.apiCallService.post(`prompts/${id}/done`, new ApicallOption());
	}
}
